import { Grid } from '@mui/material';
import { TextInput } from 'lib/common/Inputs/TextInput';
import React from 'react';

type Props = {
  observation: string | null;
  setObservation: (observation: string | null) => void;
};

const PDFInputs: React.FC<Props> = ({ observation, setObservation }) => {
  return (
    <Grid container spacing={1.5}>
      <Grid item xs={12}>
        <TextInput
          label="Observación"
          value={observation}
          onChange={setObservation}
          multiline
          rows={4}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default PDFInputs;
